import * as React from "react"

function SvgMinusbtn(props) {
  return (
    <svg height="469pt" viewBox="0 -192 469.333 469" width="469pt" {...props}>
      <path d="M437.332.168H32c-17.664 0-32 14.336-32 32V53.5c0 17.664 14.336 32 32 32h405.332c17.664 0 32-14.336 32-32V32.168c0-17.664-14.336-32-32-32zm0 0" />
    </svg>
  )
}

export default SvgMinusbtn
